import React from 'react';
import { Card, makeStyles } from '@fluentui/react-components';
import ReactMarkdown from 'react-markdown';

const useStyles = makeStyles({
    messageContainer: {
        display: 'flex',
        marginBottom: '16px',
        justifyContent: 'flex-start', // Left aligned
    },
    messageCard: {
        padding: '16px',
        borderRadius: '16px',
        width: 'fit-content', // Dynamic sizing based on content
        minWidth: '200px',
        maxWidth: '600px',
        outline: 'none',
        backgroundColor: '#292C31',
        boxShadow: 'unset',
    },
});

interface CancellationTextMessageProps {
    message: string;
}

const CancellationTextMessage: React.FC<CancellationTextMessageProps> = ({ message }) => {
    const classes = useStyles();

    return (
        <div className={classes.messageContainer}>
            <Card className={classes.messageCard}>
                <ReactMarkdown>
                    {message}
                </ReactMarkdown>
            </Card>
        </div>
    );
};

export default CancellationTextMessage;